<template>
    <div :class="[clickable ? 'cursor-pointer' : '', hideCurieId ? 'min-h-20' : 'min-h-28']" class="relative" @click="handleClick">
        <div class="flex items-start justify-between gap-2">
            <div class="line-clamp-2 min-w-0 text-lg font-bold break-words">{{ asset.name }}</div>
            <div class="shrink-0">
                <slot name="top" />
            </div>
        </div>
        <div class="mt-4 truncate font-bold">
            {{ assetLocationHierarchy }}
        </div>
        <div class="flex flex-wrap items-end justify-between gap-2">
            <div class="min-w-0">
                <div v-if="!hideCurieId" class="truncate">
                    {{ trans('general.label.curie_id') }} {{ asset.curieId || trans('general.not_available') }}
                </div>
                <div class="truncate">{{ trans('general.label.serial_number') }} {{ asset.serial_number || '-' }}</div>
                <div v-if="asset.auxiliaryHardwareSerialNumber" class="line-clamp-2 break-words">
                    {{ trans('general.label.auxiliary_hardware_serial_number') }} {{ asset.auxiliaryHardwareSerialNumber }}
                </div>
            </div>
            <slot />
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

const props = defineProps({
    asset: {
        type: Object,
        required: true,
    },
    clickable: {
        type: Boolean,
        default: false,
    },
    hideCurieId: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['asset-details-visited']);

const assetLocationHierarchy = computed(() =>
    (props.asset.location?.hierarchy ?? [])
        .map((loc) => (loc.level === 0 ? loc.iataCode : loc.name))
        .reverse()
        .join('/'),
);

function handleClick() {
    if (!props.asset || !props.clickable) return;
    router.visit(route('assets.show', props.asset));
    emit('asset-details-visited', props.asset);
}
</script>
